<button class="btn btn-primary mt-1 mb-3"
            ngbTooltip="{{'submission.workflow.generic.view-help' | translate}}"
            [routerLink]="[itemPageRoute]">
  <i class="fa fa-info-circle"></i> {{"submission.workflow.generic.view" | translate}}
</button>
